/**
 * salaAttesaOggi.js — l'indirizzo di «Oggi» portata sulla sala d'attesa, in
 * un posto solo per chi lo legge e per chi ci porta:
 *   - la pagina «Oggi» (pages/Oggi.jsx), che legge ?sezione= dall'indirizzo
 *     e, con la giornata arrivata, porta in vista chi aspetta;
 *   - il numero accanto alla voce Agenda del menu (navigazione/schermate.js,
 *     contatoreApre), che e' un collegamento suo (Alex, 3/11/2026, B6,
 *     riferita da Claude: «Numero accanto ad Agenda: si', apre "Oggi" sulla
 *     sezione della sala d'attesa»). Il clic sulla voce resta l'Agenda.
 *
 * PERCHE' «OGGI» E NON L'AGENDA. Il numero conta chi e' in sala d'attesa
 * (contatoriController, chiave 'agenda': IN_SALA_D_ATTESA di
 * services/salaAttesa.js). L'Agenda e' una griglia per agenda e per ora, e
 * non dice chi aspetta; «Oggi» ha le righe di oggi con la fase del server
 * (FASE_DELL_APPUNTAMENTO), e la fase «in_sala» e' la stessa condizione del
 * numero. Sulle stesse agende: la vista di serie di «Oggi» e' «Le mie
 * agende» per chi non vede tutto (un medico: ag.medico_id = il suo medico,
 * come filtroMedico del numero; senza medico, nessuna agenda e zero) e
 * «Tutta la clinica» per amministrazione e segreteria (come il numero, che a
 * loro conta tutti). Per questo l'indirizzo NON scrive ?vista=: la vista di
 * serie e' gia' quella del numero, e una ?vista= rimasta nell'indirizzo da
 * prima (un medico su «Tutta la clinica») il clic la toglie. Lo pretende
 * provaOggi (passo del numero di /api/contatori) dal lato del server.
 *
 * Perche' una costante e non due copie: la pagina tratta un valore che non
 * conosce come «niente» (non porta in vista niente). Con due copie, una
 * rinomina nella pagina avrebbe fatto aprire «Oggi» in cima, senza un errore.
 *
 * Fuori da components/ e da pages/: la tabella delle schermate si carica
 * anche in Node (scripts/caricaSchermate.js), e la pagina «Oggi» importa la
 * tabella.
 */

/** Il nome del parametro dell'indirizzo che dice quale parte portare in vista. */
export const PARAMETRO_SEZIONE = 'sezione';

/** Il valore di ?sezione= che porta in vista chi e' in sala d'attesa. */
export const SEZIONE_SALA = 'sala';

/** «Oggi» sulla sala d'attesa. */
export const OGGI_SALA_D_ATTESA = `/oggi?${PARAMETRO_SEZIONE}=${SEZIONE_SALA}`;

/**
 * Il nome del numero accanto alla voce Agenda, per chi non lo vede (il
 * lettore di schermo) e per chi ci passa sopra col mouse.
 */
export const descriviNumeroInSala = (n) =>
    `${n} ${n === 1 ? 'paziente' : 'pazienti'} in sala d'attesa: apri «Oggi» su chi aspetta`;
